import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ConversationInfo } from '~/features/conversations/components/ConversationInfo'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/conversations/$conversationId')({
  component: Component,
})

function Component() {
  const { botId, workspaceId, conversationId } = Route.useParams()
  return (
    <ConversationInfo conversationId={conversationId} workspaceId={workspaceId} botId={botId}>
      <Outlet />
    </ConversationInfo>
  )
}
